import { MicNoneOutlined, MicOffOutlined } from '@mui/icons-material';
import { ControlButton, ControlButtonProps } from './ControlButton.component';

export type AudioControlButtonProps = Pick<ControlButtonProps, 'isActive' | 'onToggleActive'>;

export const AudioControlButtonn: React.VFC<AudioControlButtonProps> = props => {

  return (
    <ControlButton
      enabled={{
        icon: <MicNoneOutlined />,
        tooltipTitle: 'Mute'
      }}
      disabled={{
        icon: <MicOffOutlined />,
        tooltipTitle: 'Unmute'
      }}
      {...props}
    />
  );
};
